
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowStatusDialog extends SiteEntityDialog<WorkflowStatusRow, any> {
        protected getFormKey() { return WorkflowStatusForm.formKey; }
        protected getIdProperty() { return WorkflowStatusRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowStatusRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowStatusRow.nameProperty; }
        protected getService() { return WorkflowStatusService.baseUrl; }

        protected form = new WorkflowStatusForm(this.idPrefix);

    }
}